import { Injectable, signal, computed } from '@angular/core';
import { Router } from '@angular/router';
import {
  actionInterface,
  Concrete,
  moduleInterface,
  roleMap,
  settings,
  User,
} from '../interface/user';
import { UrlServices } from '../class/url-services';
import { isEmptyObj } from '../class/utilityHelper';
import { RolePermissionService } from 'src/app/core/service/role-permission.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends RolePermissionService {
  user = signal<User>({} as User);
  siteSettings = signal<settings>({} as settings);
  dbName: string = environment.production
    ? 'mConnectAdmin'
    : 'dev_mConnectAdmin';
  
  // Computed for backward compatibility if needed, or direct access
  currentUser = computed(() => this.user());

  constructor(private router: Router) {
    super();
    this.setUserBS(this.getUser());
  }

  public get currentUserValue(): User {
    return this.user();
  }

  setUserBS(user: User) {
    this.user.set(user);
    this.user_data = user;
    this.userRoleData = user.permission || ({} as roleMap);
  }

  getUser() {
    const res: any = localStorage.getItem(this.dbName);
    return JSON.parse(res) || {};
  }

  setApplicationUser(user: User) {
    this.clearLocalStorage();
    if (user.staff) {
      user.fname = user.staff?.name || '';
      user.lname = user.staff?.last_name || '';
      user.imageUrl = user.staff.profile_image || '';
    }
    this.setUserBS(user);
    localStorage.setItem(this.dbName, JSON.stringify(user));
  }

  setLocationData(data: any) {
    localStorage.setItem(this.dbName + '_location', JSON.stringify(data));
  }

  setSiteSettings(data: any) {
    localStorage.setItem(this.dbName + '_siteSettings', JSON.stringify(data));
    this.siteSettings.set(data);
  }
  getSiteSettings() {
    const res: any = localStorage.getItem(this.dbName + '_siteSettings');
    const settings = JSON.parse(res) || {};
    this.siteSettings.set(settings);
    return settings;
  }

  getLocation() {
    const res: any = localStorage.getItem(this.dbName + '__location');
    return JSON.parse(res) || {};
  }

  loginStatus() {
    if (isEmptyObj(this.user())) {
      this.setUserBS(this.getUser());
    }
    if (this.user() && this.user().token) {
      return true;
    }
    return false;
  }

  getToken() {
    return this.user().token || '';
  }

  clearLocalStorage() {
    localStorage.removeItem(this.dbName);
    localStorage.clear();
  }

  clearSubscribe() {
    this.user.set({} as User);
  }

  logout(returnUrl: any = '') {
    const url =
      this.currentUserValue.logged_type == 'PASSWORD'
        ? '/pw'
        : UrlServices.AUTH_PAGE.LOGIN_URL;
    this.clearLocalStorage();
    this.clearSubscribe();
    this.router.navigate([url], {
      queryParams: { returnUrl: returnUrl ? returnUrl : this.router.url },
    });
  }

  isAllowable(
    mName: Concrete<keyof moduleInterface>,
    aName: Concrete<keyof actionInterface>,
  ) {
    const res = this.checkPermission(mName, aName);
    if (!res) {
      this.redirectToDenied();
    }
    return res;
  }

  redirectToLogin() {
    this.router.navigate([UrlServices.AUTH_PAGE.LOGIN_URL]);
  }
  redirectToDashboard() {
    this.router.navigate([UrlServices.DASHBOARD_ROUTE]);
  }

  redirectToDenied() {
    this.router.navigate([UrlServices.ACCESS_DENIED_ROUTE]);
  }
}
